import React, { useCallback, useMemo } from "react";
import authorization from "../../../../auth/authorization";
import { getDateFieldSorter, getTextFieldSorter, getSortOrder } from '../../../../utils/sorters';
import { ColourBorder } from "../StyledComponents";

export const useColumns = ({ sortOrder, sortBy, TableDataMap, userType }) => {
    const getTableColumns = useCallback((sortOrder, sortBy) => {
        const columns = [
          {
            title: "Case",
            width: 160,
            fixed: "left",
            key: TableDataMap.CASE_ID,
            render: (_, record) => (
                <ColourBorder inputColor={record.caseId.colourCode}>
                  <strong>{record.caseId.caseId}</strong>
                  <br />
                  {record.teleMedicineCategoryId}
                  <br />
                  <em>{record.stateId}</em>
                  <br />
                  {record[TableDataMap.CONSULTATION_TYPE]}
                  <br />
                  Status: <strong>{record[TableDataMap.STATUS]}</strong>
                </ColourBorder>
            ),    
          },
          {
            title: "Patient",
            width: 140,
            key: "patient",
            render: (_, record) => (
              <>
                <strong>{record[TableDataMap.PATIENT_NAME]}</strong>
                <br />
                {record.patientEmail}
                <br />
                <em>{record.patientId}</em>
              </>
            
            )
          },
          {
            title: "Provider",
            width: 80,
            key: TableDataMap.PHYSICIAN_ID,
            render: (text) => text || 'Unassigned',
          },
          {
            title: "Created At (UTC)",
            width: 50,
            key: TableDataMap.CREATED_DATE,
            render: (text) => (
              <div style={{ textAlign: 'right'}}>
                {text.split(' ')[0]}
                <br />
                { text.split(' ')[1] + ' ' + text.split(' ')[2]}
              </div>
            ),
          },
          {
            title: "Updated At (UTC)",
            width: 50,
            key: TableDataMap.UPDATED_DATE,
            render: (text) => (
              <div style={{ textAlign: 'right'}}>
                {text.split(' ')[0]}
                <br />
                { text.split(' ')[1] + ' ' + text.split(' ')[2]}
              </div>
            )
          }
        ]

        columns.forEach((c) => {
          c.dataIndex = c.key;
          if ([
            TableDataMap.CASE_ID,
            TableDataMap.PATIENT_ID,
          ].includes(c.key)) {
            return;
          }
          c.sortOrder = getSortOrder(sortOrder, sortBy, c.key);
          const isDateField = [
            TableDataMap.CREATED_DATE,
            TableDataMap.UPDATED_DATE,
            TableDataMap.ASSIGNED_TIME,
            TableDataMap.ASSIGNED_GROUP_TIME,
          ].includes(c.key);
          c.sorter = isDateField ? getDateFieldSorter(c.key) : getTextFieldSorter(c.key);
        });

        return { columns }
    }, [TableDataMap]);

    const checkIsAllowedAuthUser = useCallback((action) => {
      return authorization.isAllowed(userType, action);
    }, [userType]);

    const columns = useMemo(() => {
      const { columns } = getTableColumns(sortOrder, sortBy);
      return columns;
    }, [sortOrder, sortBy, checkIsAllowedAuthUser, getTableColumns]);

    return columns;
}
